/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

export class RayColors {
    /* istanbul ignore next */
    public color(name: string): this {
        return this;
    }

    public green(): this {
        return this.color('green');
    }

    public orange(): this {
        return this.color('orange');
    }

    public red(): this {
        return this.color('red');
    }

    public purple(): this {
        return this.color('purple');
    }

    public blue(): this {
        return this.color('blue');
    }

    public gray(): this {
        return this.color('gray');
    }
}
